import { render, staticRenderFns } from "./ToggleButton.vue?vue&type=template&id=845dcc02&scoped=true"
import script from "./ToggleButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToggleButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ToggleButton.vue?vue&type=style&index=0&id=845dcc02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845dcc02",
  null
  
)

export default component.exports